"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeStyle = exports.isPseudo = exports.isMediaOrPseudo = exports.isMedia = exports.deepClone = exports.createCssRule = void 0;
const isMedia = query => query.indexOf('@media') === 0;
exports.isMedia = isMedia;
const isPseudo = query => query.indexOf(':') === 0;
exports.isPseudo = isPseudo;
const isMediaOrPseudo = query => isMedia(query) || isPseudo(query);
exports.isMediaOrPseudo = isMediaOrPseudo;
const deepClone = obj => JSON.parse(JSON.stringify(obj));
exports.deepClone = deepClone;
const createCssRule = (query, stringHash, css) => {
  let rule;
  const dataMediaSelector = `[data-media~="${stringHash}"]`;
  if (isMedia(query)) {
    rule = `${query} {${dataMediaSelector} ${css}}`;
  } else {
    rule = `${dataMediaSelector}${query} ${css}`;
  }
  return rule;
};

/**
 * Sanitizes the style object by converting any functions to their string representation.
 *
 * @param {Object} style - The style object to sanitize.
 * @returns {Object} - The sanitized style object.
 */
exports.createCssRule = createCssRule;
const sanitizeStyle = style => {
  const sanitizedStyle = {
    ...style
  };
  Object.keys(sanitizedStyle).forEach(property => {
    if (typeof sanitizedStyle[property] === 'function') {
      sanitizedStyle[property] = sanitizedStyle[property].toString();
    }
  });
  return sanitizedStyle;
};
exports.sanitizeStyle = sanitizeStyle;